import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import TenantHome from './TenantHome';
import TenantRent from './TenantRent';
import TenantAmenities from './TenantAmenities';
import TenantBills from './TenantBills';
import TenantVisitors from './TenantVisitors';
import TenantComplaints from './TenantComplaints';
import TenantForum from './TenantForum';
import TenantAnnouncements from './TenantAnnouncements';
import Events from '@/pages/Events';
import TenantChat from './TenantChat';

const TenantDashboard = () => {
  return (
    <DashboardLayout role="tenant">
      <Routes>
        <Route index element={<TenantHome />} />
        <Route path="rent" element={<TenantRent />} />
        <Route path="amenities" element={<TenantAmenities />} />
        <Route path="bills" element={<TenantBills />} />
        <Route path="visitors" element={<TenantVisitors />} />
        <Route path="complaints" element={<TenantComplaints />} />
        <Route path="forum" element={<TenantForum />} />
        <Route path="announcements" element={<TenantAnnouncements />} />
        <Route path="events" element={<Events />} />
        <Route path="chat" element={<TenantChat />} />
      </Routes>
    </DashboardLayout>
  );
};

export default TenantDashboard;
